import React from 'react';
import Spinners from 'containers/NewCreativePreview/components/Spinner';

interface ProgressViewProps {
  status: React.ReactNode;
}

export const ProgressView: React.FC<ProgressViewProps> = ({ status }) => {
  return (
    <div
      style={{
        height: '587px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <div>
        <Spinners count={4} color={'#157f95'} />
        <p style={{ textAlign: 'center', marginTop: '10px' }}>{status}</p>
      </div>
    </div>
  );
};
